import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Location, _ } from '@mira-avant/mtlibs';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { AngularModule } from '../../../../modules/angular.module';
import { NameFieldComponent } from '../../../fields/standard/name-field/name-field.component';
import { FormTitleComponent } from '../../../ui/forms/form-title/form-title.component';
import { NavigationService } from '../../../../services/navigation.service';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';

@Component({
	selector: 'app-location-form',
	standalone: true,
	imports: [AppModule, ZorroModule, AngularModule, NameFieldComponent, FormTitleComponent, TextFieldComponent],
	templateUrl: './location-form.component.html',
	styleUrl: './location-form.component.scss',
})
export class LocationFormComponent {
	@Input('location') public location: Location | undefined;
	@Input('loading') public loading: boolean = false;
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();

	public form: FormGroup = this.fb.group({
		name: ['', NameFieldComponent.validators],
		ssoLocationId: [''],
	});

	constructor(
		private fb: FormBuilder,
		public nav: NavigationService
	) {}

	public onSubmit(): void {
		this.onSubmitEmitter.emit(this.form.value);
	}

	public clear(): void {
		this.form.reset();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (_.get(changes, 'location', undefined)) {
			const newLocation: Location | undefined = _.get(changes, 'location.currentValue', undefined) as
				| Location
				| undefined;

			if (newLocation) {
				this.form.patchValue({
					name: newLocation.name,
					ssoLocationId: newLocation.sso_location_id,
				});
			} else {
				this.clear();
			}
		}
	}

	ngOnInit() {}
}
